<template>
    <!-- 出库明细记录 -->
    <div class="templete_box">
        <div class="templete">
            <div class="search_box search_box_f clearfix">
                <!-- <div class="search_time search_inputBox">
                    <el-date-picker v-model="out_start" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="销售开始"></el-date-picker>
                    ~
                    <el-date-picker v-model="out_end" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="销售结束"></el-date-picker>
                </div> -->
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="out_start" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="出库开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="out_end" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="出库结束日期"></el-date-picker>
                </div>
                <div class="search_time search_inputBox">
                    <el-date-picker
                        v-model="inbound_time_start"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        placeholder="入库开始时间">
                    </el-date-picker>
                    <!-- <el-date-picker v-model="out_start" class="search_time_input" type="datetime"  value-format="yyyy-MM-dd HH:MM" placeholder="入库开始时间"></el-date-picker> -->
                    ~
                    <el-date-picker
                        v-model="inbound_time_end"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        placeholder="入库结束时间">
                    </el-date-picker>
                    <!-- <el-date-picker v-model="out_end" value-format="yyyy-MM-dd" class="search_time_input" type="datetime" placeholder="入库结束时间"></el-date-picker> -->
                </div>
                <el-input class="search_input search_inputBox" v-model="params.search.bale_no" placeholder="捆包号"></el-input>
                <select-down-customer ref="selectdowncustomer" v-if="module.indexOf('warehouse-report-out-inventory-show-customer')!=-1" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
                <el-select class="search_select search_inputBox" v-model="params.search.salesman_id" multiple collapse-tags placeholder="销售人" @visible-change="getSelectList('user')">
                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.order_sn" placeholder="销售单号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.search.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectList('breed')">
                    <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectList('brand')">
                    <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.sales_thickness" placeholder="厚度"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.sales_length" placeholder="长度"></el-input>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.grade_id" multiple collapse-tags placeholder="等级">
                    <el-option v-for="list in gradeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.warehouse_id" multiple collapse-tags placeholder="仓库" @visible-change="getSelectList('warehouse')">
                    <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.the_type" placeholder="单据类型">
                    <el-option :value="999" :label="'单据类型'"></el-option>
                    <el-option :value="1" :label="'销售出库记录'"></el-option>
                    <el-option :value="2" :label="'退货入库记录'"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.opening_company_id" placeholder="货权单位" filterable @visible-change="getSelectList('opencompany')">
                    <el-option v-for="list in selectMap.opencompany" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.attribute_id" multiple collapse-tags placeholder="属性" @visible-change="getSelectList('attribute')">
                    <el-option v-for="list in selectMap.attribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.color_id" multiple collapse-tags placeholder="选色" filterable @visible-change="getSelectList('color')">
                    <el-option v-for="list in selectMap.color" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.remark" placeholder="备注"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.contract_no" placeholder="合同号"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.bill_lading_no" placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.ship_no" placeholder="船名"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.search.batch_no" placeholder="批次号"></el-input>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.qr_code_status" placeholder="出库方式">
                    <el-option :value="0" :label="'勾选出库'"></el-option>
                    <el-option :value="1" :label="'扫码出库'"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.out_operator_id" multiple collapse-tags placeholder="出库确认人">
                    <el-option v-for="list in outOperatorList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="report.out.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @sortTable="sortTable"></tabletem>
                 <!-- @getRow="getRow" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick" -->
            </div>
            <div class="totalCal">
                <div class="totalNumber">出库立方:{{totalObj.out_cube}}</div>
                <div class="totalNumber">销售立方:{{totalObj.sales_cube}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- dialog START -->
        <!-- <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC" width="1150px" :modal="false" title="" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="eldialogTopMess clearfix">
                    <div class="topMess">客户： {{form_params.customer}}</div>
                    <div class="topMess">销售单号： {{form_params.order_sn}}</div>
                </div>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column label="捆包号" width="135" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="60" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="60" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="60" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="60" show-overflow-tooltip v-if="boardAfricaType">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_width_total }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" prop="sales_width_total" width="50" show-overflow-tooltip v-if="boardAmericaType">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_width_total }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售立方" prop="sales_cube" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="出库立方" prop="out_cube" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.out_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货片数" prop="return_pieces" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-input type="text" v-model="scope.row.return_pieces"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货立方" prop="return_cube" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-input type="text" v-model="scope.row.return_cube" @input="changeDetailTotalPrice"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售单价" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货金额(￥)" prop="totalPrice" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.totalPrice }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="remarkBox remarkBoxFourText">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.create_name}}</div>
                    <div class="editPerson">审核人：</div>
                </div>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="dialogVisible=!dialogVisible">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="backConfirm">提交审核</el-button>
                    </div>
                </div>
            </div>
        </el-dialog> -->
        <!-- dialog END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="report.out.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<style scoped lang="scss">
    .eldialogTopMess{padding:10px 0;
        .topMess{font-size: 14px;float: left;margin-right:50px;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .remarkBoxFourText{padding:5px 5px 5px 60px;}
    .remarkBoxFourText:before{content:"退货原因:";}
</style>
<script>
    import tabletem from '../../../components/table.vue'
    import pagination from '../../../components/pagination.vue'
    import selectDownCustomer from '../../../components/selectDownCustomer.vue'
    export default {
        components:{
            tabletem,
            pagination,
            selectDownCustomer
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                out_start:"",
                out_end:"",
                inbound_time_start:"",
                inbound_time_end:"",
                params:{
                    search:{
                        out_start:"",
                        out_end:"",
                        inbound_time_start:"",
                        inbound_time_end:"",
                        customer_id:"",
                        salesman_id:"",
                        order_sn:"",
                        breed_id:"",
                        brand_id:"",
                        grade_id:"",
                        warehouse_id:"",
                        bale_no:"",
                        contract_no:"",
                        bill_lading_no:"",
                        ship_no:"",
                        batch_no:"",
                        remark:"",
                        sales_length:"",
                        sales_thickness:"",
                        qr_code_status:"",
                        opening_company_id:'',
                        the_type:999
                    },
                    per_page: 50,
                    page:1
                },
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                isShowMore : false,
                breedList:[],
                brandList:[],
                warehouseList:[],
                customerList:[],
                saleList:[],
                gradeList:[],
                selectMap:{
                    user:[],
                    breed:[],
                    brand:[],
                    customer:[],
                    warehouse:[],
                    opencompany:[],
                    attribute:[],
                    color:[]
                },
                // dialog START
                dialogVisible : false,
                form_params:{
                    order_id:"",
                    remark:"",
                    order_sn:"",
                    customer:"",
                    create_name:localStorage.dw_erp_user_name
                },
                listDetail:[
                    { bale_no:"",brand:"",breed:"",grade:"",sales_thickness:"",sales_length:"",sales_width_total:"",sales_pieces:"",sales_cube:"",out_cube:"",return_pieces:"",return_cube:"",sales_price:""}
                ],
                // DIALOG END
                tableCol:[
                    {colName:"销售单号",colKey:"order_sn",colWidth:190,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售日期",colKey:"sales_time",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true,isColor:true},
                    {colName:"出库日期",colKey:"out_time",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true,isColor:true},
                    {colName:"入库日期",colKey:"inbound_time",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true,isColor:true},
                    {colName:"单据类型",colKey:"the_type",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:170,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厚度",colKey:"sales_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"sales_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"宽度",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"总宽度",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"出库立方",colKey:"out_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"采购单价",colKey:"purchase_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"最低限价",colKey:"min_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"挂牌价",colKey:"list_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"销售单价",colKey:"sales_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货权单位",colKey:"opening_company",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"属性",colKey:"attribute",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"选色",colKey:"color",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"采购金额",colKey:"purchase_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"成本费用",colKey:"cost",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"采购成本金额",colKey:"purchase_price",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"毛利",colKey:"margin",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"是否开票",colKey:"rec",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售人",colKey:"salesman_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售审核人",colKey:"auditor_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"出库审核人",colKey:"out_auditor_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"出库确认人",colKey:"out_operator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"出库方式",colKey:"qr_code_status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"板尺",colKey:"plate_ruler",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                selectRow:[],
                totalObj:{},
                filterDialogVisible:false,
                filter:"",
                fields:"",
                outOperatorList:[],
            }
        },
        created(){
            this.getBreedList().then(res=>{
                this.breedList=res.data.data;
            })
            this.getBrandList().then(res=>{
                this.brandList=res.data.data;
            })
            this.getWarehouseList().then(res=>{
                this.warehouseList=res.data.data;
            })
            this.$getCustomerList().then(res=>{
                this.customerList=res.data.data;
            })
            this.$getSalemanList().then(res=>{
                this.saleList=res.data.data;
            })
            this.getGradeList().then(res=>{
                this.gradeList=res.data.data;
            })
            this.out_start = this.monthFirstDay();
            this.out_end = new Date();
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
            this.getOutOperatorList()
        },
        methods:{
            getOutOperatorList(){
                this.postFunc('/erp/outoperator.options',{},res=>{
                    this.outOperatorList = res.data.data;
                })
            },
            exportExcelBill(){
                this.$exportExecl("/erp/report.out.export","出库记录明细导出",this.params)
            },
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                let obj = new Object();
                if(target=="user"){
                    obj.show_disabled = 1;
                }
                this.$getSelectList(target,obj).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            changeDetailTotalPrice(){
                this.listDetail.forEach(item=>{
                    item.totalPrice=parseFloat(Number(item.return_cube)*Number(item.sales_price)).toFixed(2)
                })
            },
            // backConfirm(){
            //     this.$confirm('是否确认申请退货?', '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     }).then(() => {
            //         let data = JSON.parse(JSON.stringify(this.form_params));
            //         data.detail_list = this.listDetail;
            //         this.postFunc("/erp/return.create",data,()=>{
            //             this.tip('退货申请成功','success');
            //             this.dialogVisible=false;
            //             this.getList()
            //         },error=>{
            //             this.tip(error.data.message,"warning")
            //         })
            //     }).catch(()=>{});
            // },
            // backPro(){
            //     if(this.selectRow.length<=0){
            //         this.tip("请选择数据","warning")
            //         return;
            //     }else{
            //         let order_sn_first = this.selectRow[0].order_sn;
            //         let flag = true;
            //         this.selectRow.forEach(item=>{
            //             if(item.order_sn!=order_sn_first){
            //                 flag = false;
            //             }
            //         })
            //         if(flag){
            //             this.dialogVisible=true;
            //             this.form_params.order_id=this.selectRow[0].order_id;
            //             this.form_params.order_sn=this.selectRow[0].order_sn;
            //             this.form_params.customer=this.selectRow[0].customer_name;
            //             this.selectRow.forEach(item=>{
            //                 //item.order_detail_id=item.order_detail_id;
            //                 item.return_pieces=Number(item.pieces);
            //                 item.return_cube=Number(item.sales_cube);
            //                 item.totalPrice=parseFloat(Number(item.return_cube)*Number(item.sales_price)).toFixed(2)
            //             })
            //             let list = JSON.parse(JSON.stringify(this.selectRow));
            //             this.listDetail = list;
            //         }else{
            //             this.tip("请选择同一销售单号数据","warning")
            //         }
            //     }
            // },
            // getRow(row){
            //     this.selectRow=row;
            // },
            reset(){
                this.out_start = "";
                this.out_end = "";
                this.inbound_time_start = "";
                this.inbound_time_end = "";
                this.params={search:{out_start:"",out_end:"",inbound_time_start:"",inbound_time_end:"",customer_id:"",salesman_id:"",order_sn:"",breed_id:"",brand_id:"",grade_id:"",warehouse_id:"",bale_no:"",contract_no:"",bill_lading_no:"",ship_no:"",batch_no:"",remark:"",sales_length:"",sales_thickness:"",qr_code_status:"",opening_company_id:"",the_type:999},per_page: 50,page:1}
                this.out_start = this.monthFirstDay();
                this.out_end=new Date();
                this.$refs['selectdowncustomer'].clearData()
                this.getList()
            },
             //表格排序
            sortTable(sort){
                this.params.sort = sort.order ? sort.prop:'';
                this.params.order = sort.order == "ascending"?"asc":sort.order == "descending"?"desc":"";
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.out_start=this.formatTimeZero(this.out_start);
                this.params.search.out_end=this.formatTimeZero(this.out_end);
                this.params.search.inbound_time_start=this.formatTimeZero(this.inbound_time_start);
                this.params.search.inbound_time_end=this.formatTimeZero(this.inbound_time_end);
                this.tableLoading = true;
                this.$postColumnList("/erp/report.out.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.totalObj=res.data.data.statistics;
                    this.list=res.data.data.list;
                    this.list.forEach((item,index)=>{
                        if(item.out_time!=0){
                            this.list[index].out_time = this.formatTime(item.out_time+"000")
                        }else{
                            this.list[index].out_time ='';
                        }
                        if(item.sales_time!=0){
                            this.list[index].sales_time = this.formatTime(item.sales_time+"000")
                        }
                        if(item.inbound_time&&item.inbound_time!=0){
                            this.list[index].inbound_time = this.formatTimeSecond(item.inbound_time*1000) 
                        }else{
                            this.list[index].inbound_time ='';
                        }

                        this.list[index].thickness = this.keepLimit(item.thickness)
                        this.list[index].length = this.keepLimit(item.length)
                        this.list[index].the_type = item.the_type==1?"销售记录":"退货记录"
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
